const updateField = (state, { field, newProps }) => {
  if (newProps.value !== undefined) {
    field.error = null;
    field.valid = null;
    field.value = newProps.value;
  }

  if (newProps.options !== undefined) {
    field.options = newProps.options;
  }

  if (newProps.error !== undefined) {
    field.error = newProps.error;
  }

  if (newProps.valid !== undefined) {
    field.valid = newProps.valid;
  }
};

const updateState = (state, { newState }) => {
  state.api = newState.api;
  state.details = newState.details;
  state.fields = newState.fields;
  state.name = newState.name;
  state.messages = newState.messages;
  state.offer = newState.offer;
  state.steps = newState.steps;
  state.summary = newState.summary;
};

const updateSteps = (state, { activeIndex }) => {
  if (activeIndex >= state.steps.length) {
    activeIndex = state.steps.length - 1;
  }
  state.steps.forEach((step, index) => (step.active = index === activeIndex));
};

export default {
  updateField,
  updateState,
  updateSteps
};
